import React from "react";

import "./style.scss";
import Helmet from "./common/helmet";
import NavBar from "./common/navbar";
import SubMenu from "./common/submenu";
import EscuelasVacaciones from "./layouts/escuelasVacaciones/escuelasVacaciones";
import Footer from "./common/footer";

const Layout = ({ children }) => (
  <div>
    <Helmet />
    <SubMenu />
    <NavBar />
    <EscuelasVacaciones />
    <Footer />
  </div>
);

export default Layout;
